import React, { Component } from 'react';
import { AppBar, Card, Divider, Typography, Icon, IconButton } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles/index';
import classNames from 'classnames';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as studentActions from '../../student/store/actions';
import * as Actions from '../store/actions';

const styles = theme => ({
    root: {}
});

class StudentUnscheduledCourseList extends Component {

    constructor(props) {
        super(props);
        const student_id = this.props.auth.user.data.role_info.link_id
        this.props.getSelfPacedCourses(student_id)
    }


    render() {
        const { classes, dayEvents } = this.props;

        const todoData = this.props.selfPacedCourses
            .map(course => {
                if (course.nextEvent.length === 0) {
                    return (
                        <tr key={course.course_id}>
                            <td>No Remaining Events</td>
                            <td></td>
                            <td></td>
                            <td></td>
                        </tr>
                    )
                }
                return (
                    <tr key={course.course_id}>
                        <td>{course.CourseName}</td>
                        <td>{course.nextEvent.EventName}</td>
                        <td>{course.nextEvent.EventType}</td>
                        <td>
                            <IconButton
                                style={{ padding: '0px', margin: '0px' }}
                                onClick={() => this.props.history.push(`/${course.nextEvent.EventType.toLowerCase()}/student/` + course.nextEvent.company_calendar_event_id)}
                            >
                                <Icon>edit</Icon>
                            </IconButton>
                        </td>
                    </tr>
                )
            })


        // const todoData = dayEvents.filter(e => e.Unscheduled === 1).map(event => {
        //     const eventHeader = event.eventType === 'dayEventAssignment' ? 'Assignment' : 'Quiz'
        //     return (

        //     )
        // });

        if (this.props.selfPacedCourses.length === 0) {
            return (
                <Card className={classNames(classes.root, "w-full")}>
                    <AppBar position="static">

                        <div className="p-16 pr-4 flex flex-row items-center justify-between">
                            <Typography className="h1 pr-16" color="inherit">Self-Paced Courses</Typography>
                        </div>
                    </AppBar>
                    <Typography className="h1 pr-16 text-center" color="inherit" ><a href="/course_enrollment" >Enroll Here!</a></Typography>
                    <Divider className="card-divider w-full" />
                </Card>
            )
        }

        return (
            <Card className={classNames(classes.root, "w-full")}>
                <AppBar position="static">

                    <div className="p-16 pr-4 flex flex-row items-center justify-between">
                        <Typography className="h1 pr-16" color="inherit">Self-Paced Courses</Typography>
                    </div>
                </AppBar>
                <table className="simple">
                    <thead>
                        <tr>
                            <th>Course</th>
                            <th>Next Event</th>
                            <th>Event Type</th>
                            <th>View/Complete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {todoData}
                    </tbody>
                </table>

                <Divider className="card-divider w-full" />
            </Card>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getStudentCourses: studentActions.getStudentCourses,
        getSelfPacedCourses: Actions.getSelfPacedCourses
    }, dispatch);
}

function mapStateToProps({ auth, dashboardApp }) {
    return {
        auth: auth,
        selfPacedCourses: dashboardApp.widgets.selfPacedCourses,
    }
}


export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(StudentUnscheduledCourseList)));


// WEBPACK FOOTER //
// src/main/content/dashboard/widgets/StudentUnscheduledCourseList.js